
const messages = {
    en: {
       delivery: {
          promo: {
            name: 'Promo',
            title: 'Promo management',
            subtitle: 'View, search, create, edit and delete Promo',
            creating: 'Creating Promo',
            editing: 'Editing Promo',
            deleting: 'Deleting Promo',
            showing: 'Showing Promo',
            menu: 'Promo',
            labels: {
                name: 'Name',
                price: 'Price',
                active: 'Active',
                quantity: 'Quantity',
                mode: 'Mode'
            },

          }
       }
    },
    es: {
       delivery: {
          promo: {
            name: 'Promo',
            title: 'Administración de Promo',
            subtitle: 'Ver, buscar, crear, editar, y borrar Promo',
            creating: 'Creando Promo',
            editing: 'Modificando Promo',
            deleting: 'Eliminando Promo',
            showing: 'Detalles de Promo',
            menu: 'Promo',
            labels: {
                name: 'Nombre',
                price: 'Precio',
                active: 'Activo',
                mode: 'Modo'
            },

          }
       }
    },
    pt: {
       delivery: {
          promo: {
            name: 'Promo',
            title: 'Administração de Promo',
            subtitle: 'Ver, buscar, criar, editar e usar Promo',
            creating: 'Criando Promo',
            editing: 'Edição Promo',
            deleting: 'Apagando Promo',
            showing: 'Detalhes do Promo',
            menu: 'Promo',
            labels: {
                name: 'Nombre',
                price: 'Precio',
                active: 'Activo'
            },

          }
       }
    }
}

export default messages
